import React, {useEffect, useState} from 'react';
import './pageNav.scss';
import {useNavigate, useLocation} from "react-router-dom";
import SEARCH_ICON from 'assets/icons/search_icon.svg';

interface PageNaveTypes {
    name: string,
    isActive: boolean,
    link: string
}

const PageNav = () => {
    const navigate = useNavigate();
    const {pathname, ...rest} = useLocation();
    const [pageRoutes] = useState<{ name: string, isActive: boolean, childRoutes: PageNaveTypes[] }[]>([
        {
            name: "dashboard",
            isActive: false,
            childRoutes: [
                {name: "Home", isActive: false, link: "/app/dashboard"},
                // {name: "Business", isActive: false, link: "/app/dashboard/business"},
            ]
        },

        {
            name: "business",
            isActive: false,
            childRoutes: [
                {name: "Home", isActive: false, link: "/app/business"},
                // {name: "Business", isActive: false, link: "/app/dashboard/business"},
            ]
        },
        {
            name: "education",
            isActive: false,
            childRoutes: [
                {name: "Plan Business", isActive: false, link: "/app/education/plan"},
                {name: "Start Business", isActive: false, link: "/app/education/start"},
                {name: "Grow Business", isActive: false, link: "/app/education/grow"},

            ]
        },
        {
            name: "news",
            isActive: false,
            childRoutes: [
                {name: "News & Articles", isActive: false, link: "/app/news/news"},
                {name: "Programs & Events", isActive: false, link: "/app/news/events"},

            ]
        },
    ]);

    const [activateRoutes, setActivateRoutes] = useState<PageNaveTypes[]>([]);


    useEffect(() => {
        const activeRoute = pageRoutes.filter((data) => (pathname?.includes(data.name)))
        setActivateRoutes(activeRoute[0]?.childRoutes)

    }, [pageRoutes, pathname]);

    useEffect(() => {
        console.log(rest)
        console.log(activateRoutes.map((data) => ({...data, isActive: pathname.includes(data.link)})))

        setActivateRoutes((routes) => routes.map((data) => ({...data, isActive: pathname.includes(data.link)})))
    }, [pathname]);


    return (
        <div className={'page-nav'}>
            <div className={'page-nav_wrapper'}>
                <div className={'page-nav_wrapper_routes'}>
                    {activateRoutes.map(({name, isActive, link}, index) => (
                        <div key={index + name}
                             className={['page-nav_wrapper_routes_route', isActive ? "active_route" : null].join(' ')}
                             onClick={() => navigate(link)}>
                            <span>{name}</span>
                        </div>

                    ))
                    }

                </div>
                <div className={'page-nav_wrapper_search'}>
                    <img src={SEARCH_ICON} alt=""/>
                    <input type="text" placeholder={'search'}/>
                </div>
            </div>
        </div>
    );
};

export default PageNav;
